module.exports = __webpack_public_path__ + "static/media/logo_sao_joao.4f2236a6.png";